import React from 'react';
import SignUp from '../../components/sign-up';

const SignUpPage = () => {
    return (
        <div>

            <SignUp />

        </div>
    )
}

export default SignUpPage;